import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ApplyPipeModule } from 'ngx-zcs-components';
import { Observable } from 'rxjs';
import { MatExpansionModule } from '@angular/material/expansion';
import { DeviceModbusInfo } from 'ngx-modbus';

import { BlockTitleComponent } from '../../../components/block-title/block-title.component';

@Component({
  standalone: true,
  selector: 'app-accordion-info',
  templateUrl: './accordion-info.component.html',
  styleUrls: ['./accordion-info.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  imports: [
    ApplyPipeModule,
    BlockTitleComponent,
    CommonModule,
    IonicModule,
    MatExpansionModule,
    TranslateModule,
  ],
})
export class AccordionInfoComponent {
  @Input() deviceInfo$?: Observable<DeviceModbusInfo[]>;
  @Input() defaultSection = 'basic';
  @Input() containerStyle = '';
  @Input() multiple = false;
  @Input() mode: 'ionic' | 'material' = 'ionic';
}
